<template>
  <section class="cta bg--dark-green">
    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 col-lg-8 offset-lg-2 np--all">
          <div class="cta__body push-v--mobile--medium push-v--tablet--medium push-v--desktop--large" v-html="body" />
          <a :href="externalLink" class="cta__link btn--pale-yellow">{{ buttonText }}
            <Arrow class="btn--arrow__icon btn--arrow__icon--orange" />
          </a>
        </div>
      </div>
    </div>
    <span data-entrance="fadeDown" class="cta__orange-shape" />
    <span data-entrance="flipUp" class="cta__blue-shape" />
    <span data-entrance="singleBounce" data-entrance-delay="100" class="cta__yellow-shape" />
  </section>
</template>

<script>
export default {
  props: {
    body: {
      type: String,
      default: '<p>Don\'t see the position you\'re looking for? We\'d still love to hear from you<p>',
    },
    buttonText: { type: String, required: true, default: 'Get In Touch' },
    externalLink: { type: String, required: true },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_cta.scss';
</style>
